import Authorization from '../../../../stores/Authorization';
import { IOrganizationRoleModel } from '../../../../interfaces/IUser';
import { LocalRoutes } from '../../../../utilities/LocalRoutes';
import { MenuItemNavLinkWithIcon } from '../../MenuItemNavLinkWithIcon';
import { UserUnreadQueryExportStatus } from '../../../report/unreadQueryExport/UserUnreadQueryExportStatus';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useZoneContext } from '../../../../contexts/useZoneContext';

interface IDataMenuItemProps {
    onZoneChange: (org: IOrganizationRoleModel, redirectPath?: string) => void;
}

export function DataMenuItem(props: IDataMenuItemProps) {
    const { user, isLoggedIn: isAuthenticated } = useAuthContext();
    const { buildZoneUrl, zoneGuid } = useZoneContext();
    
    const show = Authorization.isAuthorizedToAtLeastOneRoute(
        [LocalRoutes.ReportDetail, LocalRoutes.Query, LocalRoutes.ZoneNotes],
        user,
        zoneGuid
    );

    return (
        <>
            {show && (
                <div className="innerContainer">
                    <button className="btn-black bold" data-bs-toggle="dropdown">
                        DATA
                    </button>
                    <div className="dropdown-menu adjust-left">
                        {isAuthenticated && (
                            <div>
                                {Authorization.isAuthorizedToRoute(LocalRoutes.Query, user, zoneGuid) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-database"
                                        label="QUERY"
                                        to={buildZoneUrl(LocalRoutes.Query)}
                                    />
                                )}
                                {Authorization.isAuthorizedToRoute(LocalRoutes.ZoneNotes, user, zoneGuid) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-memo"
                                        label="ZONE NOTES"
                                        to={buildZoneUrl(LocalRoutes.ZoneNotes)}
                                    />
                                )}
                                {Authorization.isAuthorizedToRoute(
                                    LocalRoutes.ReportDetail,
                                    user,
                                    zoneGuid
                                ) && (
                                    <MenuItemNavLinkWithIcon
                                        icon="fal fa-file-chart-column"
                                        label="REPORT TOOL"
                                        to={buildZoneUrl(LocalRoutes.ReportTypeList)}
                                    />
                                )}
                                <MenuItemNavLinkWithIcon
                                    icon="fal fa-file-lines"
                                    label="MY DOCUMENTS"
                                    to={buildZoneUrl(LocalRoutes.MyDocuments)}
                                />
                            </div>
                        )}
                    </div>
                    <UserUnreadQueryExportStatus user={user} onZoneChange={props.onZoneChange} />
                </div>
            )}
        </>
    );
}
